import StatisticStyle from "../templates/Statistic.style";
var StatisticData = {
  name: 'statistic',
  data: [{
    titleFontSize: 12,
    titleLineHeight: 20,
    contentFontSize: 20,
    contentLineHeight: 28
  }],
  onlyTemplate: {
    base: StatisticStyle
  }
};
export default StatisticData;